import { useHotkeys } from 'react-hotkeys-hook';

export type UseWorkspaceAgentGuidedVariantOutputOptionsDockHotkeysParams = {
  onCancel: () => void;
  onContinue: () => void;
};

/** Enter continues only from the suffix field; Cancel, Continue, and Format keep their own Enter. */
const isOutputOptionsDockContinueHotkeyTarget = (target: EventTarget | null): boolean =>
  target instanceof HTMLElement && target.dataset.dockContinueOnEnter !== undefined;

const OUTPUT_OPTIONS_DOCK_HOTKEY_OPTIONS = {
  enableOnFormTags: true,
  ignoreEventWhen: (event: KeyboardEvent) => event.defaultPrevented,
  preventDefault: (event: KeyboardEvent) =>
    event.key === 'Escape' || isOutputOptionsDockContinueHotkeyTarget(event.target),
} as const;

export const useWorkspaceAgentGuidedVariantOutputOptionsDockHotkeys = ({
  onCancel,
  onContinue,
}: UseWorkspaceAgentGuidedVariantOutputOptionsDockHotkeysParams) => {
  const dockRef = useHotkeys<HTMLElement>(
    'escape, enter',
    (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onCancel();
        return;
      }

      if (!isOutputOptionsDockContinueHotkeyTarget(event.target)) {
        return;
      }

      onContinue();
    },
    OUTPUT_OPTIONS_DOCK_HOTKEY_OPTIONS,
    [onCancel, onContinue],
  );

  return { dockRef };
};
